import { render, staticRenderFns } from "./aws-claude.vue?vue&type=template&id=1f996ca3&scoped=true"
import script from "./aws-claude.vue?vue&type=script&lang=js"
export * from "./aws-claude.vue?vue&type=script&lang=js"
import style0 from "./aws-claude.vue?vue&type=style&index=0&id=1f996ca3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f996ca3",
  null
  
)

export default component.exports